<template>
  <div>
    <header-bar>
      {{ type === 'album' ? 'アルバム（2曲以上）': 'シングル' }}配信
    </header-bar>
    <div class="page-block">
      <div
        class="page-block__heading page-block__heading--withbar">
        <h3 class="page-block__title">リリース情報登録 - 決済情報登録</h3>
        <release-type-label :type="type" />
      </div>
      <div class="page-block__inner">
        <release-step-area
          :index="5">
          プランを選択後、決済情報をご登録下さい
        </release-step-area>
        <alert-view
          title="決済処理が完了しませんでした"
          :errors="payment_errors" />
        <div class="form-wrap form--error">
          <div class="form-group">
            <div class="form-label">
              <label
                class="control-label">プラン<span class="req">＊</span></label>
            </div>
            <div class="form-item">
              <div class="form-item-inline">
                <div class="radio">
                  <label for="planSubscription">
                    <input
                      id="planSubscription"
                      v-model="service_plan"
                      type="radio"
                      name="plan"
                      :value="2"
                      checked>
                    <div class="option-input"></div> 配信し放題プラン
                  </label>
                </div>
                <div class="radio">
                  <label for="planBasic">
                    <input
                      id="planBasic"
                      v-model="service_plan"
                      type="radio"
                      name="plan"
                      :value="1">
                    <div class="option-input"></div> 1回払いきりプラン
                  </label>
                </div>
              </div>
              <div class="form-group-wrap__btn-wrap">
                <router-link
                  :to="{ name: 'faq-detail', params: { id: 71 } }"
                  class="c-btn c-btn--narrow"
                  target="_blank">
                  プラン詳細を見る<span class="c-btn__icon-arrow"></span>
                </router-link>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="form-label">
              <label
                class="control-label">決済方法<span class="req">＊</span></label>
            </div>
            <div class="form-item">
              <div class="form-item-inline">
                <div class="radio">
                  <label for="paymentCard">
                    <input
                      id="paymentCard"
                      v-model="payment_method"
                      type="radio"
                      name="settlement"
                      :value="1"
                      checked>
                    <div class="option-input"></div> クレジットカード
                  </label>
                </div>
                <div class="radio">
                  <label for="paymentMobile">
                    <input
                      id="paymentMobile"
                      v-model="payment_method"
                      type="radio"
                      name="settlement"
                      :value="2">
                    <div class="option-input"></div> キャリア決済
                  </label>
                </div>
                <div
                  v-if="coupon_ids.length!=0"
                  class="radio">
                  <label for="paymentCoupon">
                    <input
                      id="paymentCoupon"
                      v-model="payment_method"
                      type="radio"
                      name="settlement"
                      :value="3">
                    <div class="option-input"></div> シングル一枚無料配信キャンペーン（初回のみ）
                  </label>
                </div>
              </div>
              <p class="form-caution-text">※キャリア決済の場合、事務手数料が発生いたします。</p>
              <p
                v-if="coupon_ids.length!=0"
                class="form-caution-text">
                ※クーポンコードをご利用の方は「シングル一枚無料配信キャンペーン（初回のみ）を選択してください。
              </p>
            </div>
          </div>
          <credit-card
            v-show="payment_method === 1"
            @update="cardUpdate" />
          <div
            v-if="payment_method === 2"
            class="form-group">
            <div class="form-label">
              <label
                class="control-label">
                キャリア選択<span class="req">＊</span></label>
            </div>
            <div class="form-item">
              <div class="form-item-inline">
                <div class="c-select_wrap">
                  <select
                    v-model="carrier"
                    class="form-control c-select"
                    name="language">
                    <option
                      value="0"
                      disabled
                      selected
                      style="display:none;">
                      選択してください
                    </option>
                    <option value="2">NTTドコモ</option>
                    <option value="3">au</option>
                    <option value="4">ソフトバンク</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="payment_method === 3"
            class="form-group">
            <div class="form-label">
              <label
                class="control-label">
                クーポンコード<span class="req">＊</span></label>
            </div>
            <div class="form-item">
              <input
                v-model="coupon_code"
                class="form-control"
                type="text"
                @input="onInputCouponCode()">
              <p class="form-caution-text">※アカウント登録完了メールに記載してあるクーポンコードを入力してください。</p>
              <p
                v-if="errors.coupon_code"
                class="form-caution-text">
                {{ errors.coupon_code }}
              </p>
            </div>
          </div>
        </div>
        <div
          v-show="payment_method_id > 0 && payment_method_id!==5"
          class="settlement-plan-list">
          <table class="settlement-plan-list__table">
            <tbody class="settlement-plan-list__tbody">
              <tr
                v-for="item in price_data.breakdown"
                :key="item.id">
                <td class="u-text-align-left">{{ item.name }}</td>
                <td>{{ item.price }}円</td>
              </tr>
              <tr
                v-if="service_plan === 1"
                class="total">
                <td class="u-text-align-left">{{ price_data.amount.name }}</td>
                <td>{{ price_data.amount.price }}円</td>
              </tr>
              <tr
                v-else
                class="total">
                <td class="u-text-align-left">{{ price_data.amount.name }}</td>
                <td>
                  {{ price_data.amount.price }}円
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          v-if="service_plan === 2 && payment_method_id > 0"
          class="campaign-block">
          <h3>■解約について</h3>
          <p>
            「配信し放題プラン」の最低契約期間は1年間となります。ご契約期間が1年間未満の場合、解約料として1,320円(税込)を解約手続き時にお支払いいただきます。
          </p>
          <p class="notice">
            ※ キャリア決済の場合、解約料の他に事務手数料が発生いたします。
          </p>
          <div class="withdrawal-form-wrap">
            <div class="checkbox">
              <label>
                <input
                  v-model="campaignAgreeement"
                  type="checkbox">
                <div class="option-input"></div>
                上記、全てに同意して契約する
              </label>
            </div>
          </div>
        </div>
        <div class="c-btn-wrap">
          <a
            v-if="payment_method_id!==5"
            :class="['c-btn',{'c-btn--off':confirmButtonDisabled
              || (!campaignAgreeement && service_plan === 2)}]"
            @click.prevent="paymentClick">
            支払いする<span class="c-btn__icon-arrow"></span>
          </a>
          <a
            v-else
            :class="['c-btn',{'c-btn--off':!coupon_verify}]"
            @click.prevent="paymentClick">配信審査を依頼する</a>
          <a
            class="c-btn c-btn--back c-btn--back-left"
            @click.prevent="onBackClicked">
            アカウント情報確認画面へ戻る<span class="c-btn__icon-arrow c-btn__icon-arrow--left"></span>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import lodash from 'lodash'
import moment from 'moment'
import ReleaseStepArea from '../StepArea'
import HeaderBar from '../../HeaderBar'
import ReleaseTypeLabel from '../ReleaseTypeLabel'
import AlertView from '../../AlertView'
import CreditCard from '../../SettlementMethod/CreditCard'

export default {
  name: 'ReleaseStep5',
  components: {
    ReleaseStepArea,
    HeaderBar,
    ReleaseTypeLabel,
    AlertView,
    CreditCard,
  },
  data() {
    return {
      product: {},
      service_plan: 2,
      payment_method: 1,
      carrier: 0,
      type: '',
      card_validated: false,
      card_info: {},
      price_data: {
        amount: {
          name: '',
          price: '',
        },
        product: {
          id: 0,
          name: '',
          price: '',
        },
        breakdown: [],
      },
      payment_errors: [],
      confirmButtonDisabled: true,
      campaignAgreeement: false,
      errors: {},
      coupon_ids: [],
      coupon_verify: false,
      coupon_code: '',
    }
  },
  computed: {
    payment_method_id() {
      if (this.payment_method === 1) {
        return 1
      }
      if (this.payment_method === 3) {
        // クーポン支払い
        return 5
      }
      return this.carrier
    },
    service_plan_id() {
      if (this.service_plan === 1) {
        return this.type === 'single' ? 1 : 2
      }
      if (this.service_plan === 2) {
        return 6
      }
      return 0
    },
    cancellationPeriod() {
      return moment().add('months', 2).endOf('month').format('YYYY年M月D日')
    },
    startBillingMonth() {
      return moment().add('months', 3).format('YYYY年M月')
    },
  },
  watch: {
    service_plan() {
      if (this.payment_method_id > 0) this.fetchPrice()
      else this.fetchCoupons()
    },
    payment_method() {
      this.confirmButtonDisabled = !this.validate()
    },
    payment_method_id(value) {
      if (value > 0) {
        this.fetchPrice().then(() => {
          this.confirmButtonDisabled = !this.validate()
        })
      } else {
        this.confirmButtonDisabled = true
      }
    },
    card_info: {
      handler() {
        this.confirmButtonDisabled = !this.validate()
      },
      deep: true,
    },
  },
  mounted() {
    const release = JSON.parse(window.sessionStorage.getItem('album'))
    if (!release) {
      this.$router.push({ name: 'index' })
      return
    }
    this.product = release.product || {}
    this.type = release.type
    this.fetchPrice()
  },
  methods: {
    async fetchPrice() {
      try {
        const { data } = await window.axios.get('/api/client/settlement/amount', {
          params: {
            service_plan: this.service_plan,
            product_id: this.product.id,
            payment_method_id: this.payment_method_id,
            coupon_code: this.payment_method_id === 5 ? this.coupon_code : null,
          },
        })
        if (data.result === true) {
          this.price_data.amount = data.amount
          this.price_data.product = data.product
          this.price_data.breakdown = data.breakdown
        }
        this.fetchCoupons()
      } catch ({ response }) {
        this.$store.commit('decrementLoadingCount')
        this.$store.dispatch('progress/reset')
      }
    },
    async fetchCoupons() {
      try {
        this.coupons = []
        const { data } = await window.axios.get('/api/client/settlements/coupon', {
          params: {
            service_plan_id: this.service_plan_id,
          },
        })
        this.coupon_ids = data.ids
      } catch ({ response }) {
        this.$store.commit('decrementLoadingCount')
        this.$store.dispatch('progress/reset')
      }
    },
    async verifyCouponCode() {
      try {
        this.$set(this.errors, 'coupon_code', null)
        const { data } = await window.axios.get('/api/client/settlements/coupon/verify', {
          params: {
            service_plan_id: this.service_plan_id,
            coupon_code: this.coupon_code,
          },
        })
        if (data.result === true) {
          this.coupon_verify = true
        } else {
          this.coupon_verify = false
          this.$set(this.errors, 'coupon_code', data.message)
        }
        this.fetchPrice()
      } catch ({ response }) {
        this.$store.commit('decrementLoadingCount')
        this.$store.dispatch('progress/reset')
      }
    },
    onInputCouponCode: lodash.debounce(function onInputCouponCode() {
      this.verifyCouponCode()
    }, 1000),
    async paymentClick() {
      this.payment_errors = []
      if (this.payment_method === 1) { // カード決済
        const apiKey  = await this.getApiKey()
        await window.axios.post('https://api.veritrans.co.jp/4gtoken', {
          card_number: this.card_info.card_number,
          card_expire: this.card_info.card_expire,
          security_code: this.card_info.security_code,
          token_api_key: apiKey,
          lang: 'ja',
        }).then(async ({ data: mdkData }) => {
          const postUrl = this.service_plan === 1 ? 'basic' : 'subscription'
          await window.axios.post(`/api/client/settlements/veritrans/card/${postUrl}`, {
            product_id: this.product.id,
            payment_method_id: this.payment_method_id,
            token: mdkData.token,
          }).then(async ({ data }) => {
            if (data.result) {
              await this.$router.push({ name: `${this.$route.meta.sideMenuId}-completed` })
            } else {
              window.scrollTo(0, 0)
              this.payment_errors.push({ message: data.message })
            }
          }).catch(() => {
            window.scrollTo(0, 0)
            this.payment_errors.push({ message: '問題が発生しました。時間を空けて再度お試し下さい' })
          })
        }).catch(({ response }) => {
          this.$store.commit('decrementLoadingCount')
          this.$store.dispatch('progress/reset')
          window.scrollTo(0, 0)
          this.payment_errors.push({ message: response.data.message })
        })
      } else if (this.payment_method === 2) {
        const postUrl = this.service_plan === 1 ? 'basic' : 'subscription'
        const baseUrl = (document.location.protocol ? 'https://' : 'http://') + document.domain
        await window.axios.post(`/api/client/settlements/veritrans/carrier/${postUrl}`, {
          product_id: this.product.id,
          payment_method_id: this.payment_method_id,
          success_url: `${baseUrl}/client/release-${this.type}/completed`,
          cancel_url: baseUrl,
          error_url: baseUrl,
        }).then(async ({ data }) => {
          if (data.result) {
            const redirectContent = data.responseContents
            document.write(redirectContent)
          } else {
            window.scrollTo(0, 0)
            this.payment_errors.push({ message: data.message })
          }
        }).catch(() => {
          window.scrollTo(0, 0)
          this.payment_errors.push({ message: '問題が発生しました。時間を空けて再度お試し下さい' })
        })
      } else if (this.payment_method === 3) {
        const postUrl = this.service_plan === 1 ? 'basic' : 'subscription'
        await window.axios.post(`/api/client/settlements/coupon/${postUrl}`, {
          product_id: this.product.id,
          payment_method_id: this.payment_method_id,
          coupon_code: this.coupon_code,
        }).then(async ({ data }) => {
          if (data.result) {
            await this.$router.push({ name: `${this.$route.meta.sideMenuId}-completed` })
          } else {
            window.scrollTo(0, 0)
            this.payment_errors.push({ message: data.message })
          }
        }).catch(() => {
          window.scrollTo(0, 0)
          this.payment_errors.push({ message: '問題が発生しました。時間を空けて再度お試し下さい' })
        })
      }
    },
    async getApiKey() {
      const { data }  = await window.axios.get('/api/client/settlements/veritrans/api_key')
      return data.token
    },
    cardUpdate(value) {
      this.card_validated = value.validated
      this.card_info = value.card_info
    },
    onBackClicked() {
      window.sessionStorage.setItem('back_from_payment_page', 'true')
      this.$router.push({ name: `${this.$route.meta.sideMenuId}-step3` })
    },
    validate() {
      if (this.payment_method === 2) {
        return this.payment_method_id >= 2
      }
      return this.card_validated
    },
  },
}
</script>
<style lang="scss" scoped>
.campaign-block{
  margin-top: 30px;
  padding: 0 20px;
  &__title{
    text-align: center;
    margin-bottom: 2em;
  }
  h3{
    font-weight: normal;
    margin-top: 2em;
  }
  p{
    margin: 1em 0;
    span{
      color:#f00;
      font-weight: bold;
    }
    .cancellationPeriod{
      margin: 1.5em 0;
    }
  }
  .withdrawal-form-wrap{
    margin-top: 50px;
  }
  .notice{
    font-size: 14px;
  }
}
</style>
